import React from "react";
import { Alert, Portal, Snackbar } from "@mui/material";
import { lighten } from "@mui/material/styles";

export default function AppSnackbar({
  open,
  message,
  severity = "info",
  onClose,
  action,
  autoHideDuration = 4000,
}) {
  return (
    <Portal>
    <Snackbar
      open={Boolean(open)}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        severity={severity || "info"}
        onClose={onClose}
        action={action}
        sx={{
          width: "100%",
          backgroundColor: (theme) => lighten(theme.palette[severity || "info"].main, 0.96),
          border: "1px solid",
          borderColor: `${severity || "info"}.main`,
          borderLeftWidth: "5px",
          borderRadius: "0 8px 8px 0",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
    </Portal>
  );
}
